import { render, staticRenderFns } from "./ModalContentFontSettings.vue?vue&type=template&id=c2e431f8"
import script from "./ModalContentFontSettings.vue?vue&type=script&lang=js"
export * from "./ModalContentFontSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports